module.exports = __webpack_public_path__ + "static/img/info-right-bg.f0a4cf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/info-right-bg.png
// module id = Bf8L
// module chunks = 4